import React, { useEffect, useState } from 'react';

function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

const NewsletterArchive = () => {
  const [newsletters, setNewsletters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchNewsletters = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await fetch('/api/newsletter_archive');
        if (!res.ok) throw new Error('Failed to fetch newsletters');
        const data = await res.json();
        setNewsletters(data.newsletters || []);
      } catch (err) {
        setError('Error loading newsletters.');
      } finally {
        setLoading(false);
      }
    };
    fetchNewsletters();
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: '2rem auto', padding: 20 }}>
      <h1>Newsletter Archive</h1>
      <p>Browse our past newsletters and stay up to date with our work for children's education and safety.</p>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {newsletters.length === 0 && !loading && <li>No newsletters found.</li>}
        {newsletters.map((nl, idx) => (
          <li key={idx} style={{ marginBottom: 32, borderBottom: '1px solid #eee', paddingBottom: 16 }}>
            <h2 style={{ margin: 0 }}>{nl.subject || '[No Subject]'}</h2>
            <div style={{ color: '#888', fontSize: 14 }}>{formatDate(nl.timestamp)}</div>
            <div dangerouslySetInnerHTML={{ __html: nl.content || '' }} style={{ marginTop: 12 }} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NewsletterArchive; 